export function formatDateYMD(d?: string | null, fallback = "—"): string {
  if (!d) return fallback;
  const ts = Date.parse(d);
  return Number.isNaN(ts) ? d : new Date(ts).toISOString().slice(0, 10);
}